import React, { useState } from 'react';
import { Button, Modal, Box, SpaceBetween } from '@amzn/awsui-components-core';
import BrowserHistory from '../utils/BrowserHistory';

import { FeedbackRating } from './FeedbackTypes';

interface Props {
  ratingType: FeedbackRating;
  showFeedbackModal: boolean;
  hideFeedbackModal: () => void;
  contentId: string;
}

const FeedbackModal = ({ ratingType, showFeedbackModal, hideFeedbackModal, contentId }: Props) => {
  const description = `If you can, please give us more details on what about this ${ratingType === FeedbackRating.Like ? ' was good.' : 'needs work.'}`;

  return (
    <Modal
      onDismiss={hideFeedbackModal}
      visible={showFeedbackModal}
      size="medium"
      header={ratingType === FeedbackRating.Like ? 'Like' : 'Dislike'}
      closeAriaLabel="Close modal"
    >
      <Box variant="p">Thanks for the feedback!</Box>
      <Box variant="p" padding={{ bottom: 's' }}>
        {description}
      </Box>
      <div>
        <Button
          onClick={() => BrowserHistory.push(`/publication-feedback/${contentId}/${ratingType}`)}
        >
          Submit feedback
        </Button>
      </div>
    </Modal>
  );
};

export default FeedbackModal;
